module.exports = __webpack_public_path__ + "images/banner-hunan.jpg?64d031306484923f33ee8d4a1cd54cb8";


//////////////////
// WEBPACK FOOTER
// ./src/images/active/banner-hunan.jpg
// module id = 173
// module chunks = 1